import { ADMIN_CONTACT_TOKEN, BASE_URL } from "@utils/constants.util"
import axios from "axios"
import { useQuery } from "@tanstack/react-query"

async function fetchAdminContactEmail(userId: string): Promise<string | null> {
	try {
		const { data } = await axios.get(`${BASE_URL}/auth/admin-contact`, {
			params: { userId },
			headers: {
				Authorization: `Bearer ${ADMIN_CONTACT_TOKEN}`
			}
		})
		return data.data.adminEmail
	} catch {
		return null
	}
}

export function useAdminContactEmail(username?: string, enabled = false) {
	return useQuery({
		queryKey: ["adminContactEmail", username],
		queryFn: () => fetchAdminContactEmail(username as string),
		enabled: enabled && !!username,
		retry: false
	})
}
